// Styles for HeaderSection go here.
import styled from 'styled-components';

export const StyledHeaderSection = styled.div``;
